export default __webpack_public_path__ + "static/media/myth.d36c081c.svg";